import assetPath from "../../utils/assetPath";

const imgEditIcon   = assetPath("/icons/edit-icon.png");
const imgDeleteIcon = assetPath("/icons/delete-icon.png");
const imgBadgeIcon  = assetPath("/icons/badge-icon.svg");

interface TierCardProps {
  name: string;
  iconBg: string;
  badgeColor?: string;
  pointsRange: string;
  onEdit?: () => void;
  onDelete?: () => void;
}

const darken = (hex: string, amount = 0.35): string => {
  const n = parseInt(hex.replace("#", ""), 16);
  const r = Math.max(0, (n >> 16) - Math.round(255 * amount));
  const g = Math.max(0, ((n >> 8) & 0xff) - Math.round(255 * amount));
  const b = Math.max(0, (n & 0xff) - Math.round(255 * amount));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`;
};

const TierCard = ({ name, iconBg, badgeColor, pointsRange, onEdit, onDelete }: TierCardProps) => {
  return (
    <div
      className="flex flex-col gap-[15px] px-6 py-5 rounded-[8px] border"
      style={{
        backgroundColor: "#e8e2da",
        borderColor: "rgba(194,199,201,0.1)",
        boxShadow: "0px 1px 1px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header: icon + name */}
      <div className="flex items-center gap-5">
        <div
          className="flex items-center justify-center w-12 h-12 rounded-[4px] shrink-0"
          style={{ backgroundColor: iconBg }}
        >
          <div
            className="w-4 h-[21px] shrink-0"
            style={{
              backgroundColor: badgeColor ?? darken(iconBg),
              WebkitMaskImage: `url(${imgBadgeIcon})`,
              maskImage: `url(${imgBadgeIcon})`,
              WebkitMaskRepeat: "no-repeat",
              maskRepeat: "no-repeat",
              WebkitMaskSize: "contain",
              maskSize: "contain",
            }}
          />
        </div>
        <h3 className="text-[18px] font-semibold text-content-heading">
          {name}
        </h3>
      </div>

      {/* Divider + footer */}
      <div className="border-t pt-[17px] flex items-center justify-between" style={{ borderColor: "#e9e9df" }}>
        <span className="text-[12px] font-medium text-brand-teal">
          {pointsRange}
        </span>
        <div className="flex items-center gap-2">
          <button
            onClick={onEdit}
            className="flex items-center justify-center hover:opacity-80 transition-opacity"
            aria-label="Edit tier"
          >
            <img src={imgEditIcon} alt="Edit" className="w-[12px] h-[12px]" />
          </button>
          {onDelete && (
            <button
              onClick={onDelete}
              className="flex items-center justify-center opacity-60 hover:opacity-100 transition-opacity"
              aria-label="Delete tier"
            >
              <img src={imgDeleteIcon} alt="Delete" className="w-[12px] h-[12px]" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TierCard;
